import * as React from 'react'
import { CodeBlock } from '../../../ui/codeBlock'

interface Props {
    message?: {
        args: {
            ct: number
        }
    }
}

const codeBefore = `$result = get_browser($bot);
if ($result->crawler) {
    $crawler['get_browser']++;
}`

const codeAfter = `use Jaybizzle\\CrawlerDetect\\CrawlerDetect;

$crawlerDetect = new CrawlerDetect();
if ($crawlerDetect->isCrawler($bot)) {
    $crawler['jaybizzle']++;
}`
export default class GetBrowserReplacement extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        let info = <div></div>

        if (message) {
            info = (
                <div>
                    The <code>get_browser</code> function was called {message.args.ct} times in this trace.
                </div>
            )
        }
        return (
            <div>
                {info}

                <p>
                    <code>get_browser</code> is slow and should be replaced by <code>JayBizzle\CrawlerDetect</code>
                </p>
                <p>
                    Even for a single call, <code>get_browser</code> is a slow call. You should consider replacing it with the composer
                    library
                    <code>jaybizzle/crawler-detect</code>. See{' '}
                    <a href="https://tideways.com/profiler/blog/choosing-a-php-library-based-on-performance">this blog post</a> for details.
                </p>
                <p>Before:</p>
                <CodeBlock code={codeBefore} language="php" />
                <p>After:</p>
                <CodeBlock code={codeAfter} language="php" />
            </div>
        )
    }
}
